import React, { FC } from 'react'

import { css } from '@emotion/core'
import { useTheme } from 'emotion-theming'

import Typography from 'components/common/atoms/Typography'

type StepBoxProps = {
  idx: number
  title: string
  description: string
}

const stepBoxStyle = (theme: ThemeType) => css`
  .step-box {
    &__wrapper {
      height: inherit;
      padding: 16px;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(26, 52, 79, 0.1);
    }
    &__label {
      padding: 2px 4px;
      margin-bottom: 12px;
      background-color: ${theme.campus.aqua30};
      display: inline-block;
      border-radius: 4px;
    }
    &__title {
      margin-bottom: 8px;
    }
    @media screen and (min-width: 768px) {
      &__title {
        margin-bottom: 16px;
        height: 48px;
      }
    }
  }
`

const StepBox: FC<StepBoxProps> = ({ idx, title, description }) => {
  const theme: ThemeType = useTheme()
  return (
    <div className="step-box" css={stepBoxStyle(theme)}>
      <div className="step-box__wrapper">
        <div className="step-box__label">
          <Typography variant="body" level="4" tagName="p" color={theme.neutral.white} fontWeight="bold">
            {`TAHAP ${idx}`}
          </Typography>
        </div>
        <Typography variant="paragraph" level="1" tagName="p" fontWeight="bold" className="step-box__title">
          {title}
        </Typography>
        <Typography variant="paragraph" level="1" tagName="p">
          {description}
        </Typography>
      </div>
    </div>
  )
}

export default StepBox
